import _ from 'lodash'
import { AnyColor, colord as nativeColord, Colord as NativeColored, HslaColor } from 'colord'

export const lightenRelative = (color: AnyColor | NativeColored, amount: number): HslaColor => {
  const hsla = nativeColord(color).toHsl()

  return {
    h: hsla.h,
    s: hsla.s,
    l: _.clamp(hsla.l * (1 + amount), 0, 100),
    a: hsla.a
  }
}
